export default __webpack_public_path__ + "static/media/avgResalePrice.5c0fc74d.svg";